var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElumiconos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3514.1 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #990089;\n      }\n\n      .cls-2 {\n        fill: #f4d934;\n      }\n\n      .cls-3 {\n        fill: #3f5ae9;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_15);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15",
    "data-name": "Degradado sin nombre 15",
    x1: 2055.18,
    y1: 441.4,
    x2: 2478.76,
    y2: 101.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#90ff3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6a9d3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ELUM_ICONOS",
    "data-name": "ELUM ICONOS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.73,71.57l-1.91,60.44c12.36-9.4,25.96-16.84,40.36-22.15l37.04-59.72-28.59-46.1c-35.15,6.31-68.59,19.91-98.22,40.02l51.32,27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.79,146.01l28.9,53.92c6.73-17.48,16.58-33.66,29.3-47.8l2.15-68.09-48.43-25.96c-3.22,2.65-6.41,5.35-9.52,8.16-25.76,23.32-46.1,51.03-60.34,81.61l57.95-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.13,252.02l1.86,1.15,50.93,31.59c-2.21-11.88-3.05-24.1-2.44-36.48.5-10.06,1.97-19.91,4.31-29.48l-31.3-58.4-55.78,1.76C7.65,187.74,1.72,215.06.32,243.31c-.65,13.13-.3,26.15,1,38.99l48.82-30.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M427.82,445.77c52.25-47.31,82.11-112.19,84.08-182.67,1.85-66.23-21.64-129.77-66.13-178.92C397.33,30.68,328.13,0,255.92,0c-4.78,0-9.55.15-14.3.41l30.84,49.73-31.55,50.87c4.97-.48,9.98-.73,15.01-.73,43.94,0,86.05,18.66,115.51,51.2,27.06,29.89,41.35,68.54,40.23,108.82-1.2,42.89-19.36,82.35-51.14,111.13-28.69,25.98-65.78,40.29-104.43,40.29-43.95,0-86.05-18.66-115.51-51.2-17.34-19.15-29.4-41.79-35.56-66.14l-54.89-34.04-47.9,29.71c6.74,51.04,28.71,98.8,64.01,137.78,48.44,53.5,117.64,84.18,189.85,84.18,63.57,0,124.57-23.52,171.74-66.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1480.18,468.22h0c-23.14,13.11-55.82,24.09-94.49,31.73-39.88,7.89-85.43,12.05-131.71,12.04-46.28,0-91.83-4.19-131.71-12.08-38.67-7.66-71.34-18.64-94.48-31.76h0c-36.15-20.88-48.58-67.29-27.7-103.44l188.69-326.71c13.41-23.22,38.42-37.73,65.27-37.86,26.85.14,51.85,14.65,65.26,37.88l188.6,326.77c20.87,36.16,8.43,82.56-27.73,103.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3392.26,
    width: 121.83,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3189.07,
    width: 121.83,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2985.88,
    width: 121.83,
    height: 512
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2523.51.15v382.32h-87.15V86.72h-149.46v64.38h-87.15V.15h323.75ZM2048.87,195.4v230.02h-68.4v86.58h155.55v-234.12h149.46v234.12h87.15V191.31h-323.75v4.09ZM2164.56,425.42h95.09v-118.66h-95.09v118.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElumiconos);
export default __webpack_public_path__ + "static/media/ELUM ICONOS.f815fcb52a9f80cc6d9bec34a0913033.svg";
export { ForwardRef as ReactComponent };